import React from 'react';

import { DynamicMediaItem } from '@uncinc/react-drupal-core';

import { TargetAudienceCard } from '../../../../components';
import type { TaxonomyTargetAudience } from '../../../../types/uncinc_profile/taxonomy';
import type { ViewNestedTaxonomiesProps } from '..';

import './style.scss';

const ViewNestedTaxonomiesTargetAudiences: React.FC<Pick<ViewNestedTaxonomiesProps, 'entities' | 'title'>> = (props) => {
  const { entities, title } = props;

  if (entities.size === 0) {
    return null;
  }

  return (
    <div className="ViewNestedTaxonomies--TargetAudiences">
      {title && (
        <h2>{title}</h2>
      )}

      <ul className="row">
        {entities.map((entity) => {
          const taxonomyTerm = entity.toJS() as TaxonomyTargetAudience;
          const uuid = taxonomyTerm.uuid[0].value;
          const langcode = taxonomyTerm.langcode[0].value;
          const key = `${uuid}:${langcode}`;

          return (
            <li key={key} className="col-lg-4">
              <TargetAudienceCard
                type="secondary"
                title={taxonomyTerm.name[0].value}
                subtitle={taxonomyTerm.field_description_with_summary?.[0]?.summary}
                link={taxonomyTerm.paths[langcode]}
                image={(
                  <DynamicMediaItem
                    // Styles are currently incompatible. There is a ticket to fix this:
                    // https://uncinc.monday.com/boards/978131166/pulses/8288766678
                    // @ts-expect-error
                    media={taxonomyTerm.field_media_item[0]}
                    imageAspectRatio="1_1"
                    alt=""
                  />
                )}
              />
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default ViewNestedTaxonomiesTargetAudiences;
